<template>
  <el-card class="h-full" :body-style="{ padding: '20px', height: '100%' }">
    <!-- search condition start -->
    <el-row>
      <el-input
        v-model="searchCondition.keyWord"
        clearable
        size="small"
        placeholder="编码/名称"
        class="w-200px mr-10px"
      ></el-input>
      <el-select
        class="w-200px mr-10px"
        v-model="searchCondition.type"
        filterable
        allow-create
        clearable
        size="small"
        :placeholder="$t('请选择类型')"
      >
        <el-option
          v-for="item in apiTypes"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select>
      <el-select
        class="w-200px mr-10px"
        clearable
        v-model="searchCondition.state"
        :placeholder="$t('请选择状态')"
      >
        <el-option
          :label="item.label"
          :value="item.value"
          v-for="(item, index) in statusList"
          :key="index"
        ></el-option>
      </el-select>
      <el-button type="primary" @click="searchTableData">{{ $t('search') }}</el-button>
      <el-button
        :disabled="!$hasAccess('create')"
        type="primary"
        @click="$router.push('./api-release-create')"
        >{{ $t('create') }}</el-button
      >
      <el-button
        type="primary"
        @click="batchPublish"
        :disabled="!$hasAccess('publish') || idList.length === 0"
        :loading="publishLoading"
      >
        发布</el-button
      >
      <el-button
        type="danger"
        @click="deleteRow(idList)"
        :disabled="!$hasAccess('delete') || idList.length === 0"
        >{{ $t('delete') }}</el-button
      >
      <el-button size="small" @click="importFile">{{ $t('import') }}</el-button>
      <el-button size="small" @click="exportFile" :loading="exportLoading">{{
        $t('export')
      }}</el-button>
    </el-row>
    <!-- search condition end -->
    <!-- table start -->
    <el-table
      ref="table"
      :data="tableData"
      class="mt-20px"
      border
      height="calc(100% - 106px)"
      v-loading="tableLoading"
      @selection-change="selectionChange"
      row-key="id"
    >
      <el-table-column type="selection" :reserve-selection="true" width="55"></el-table-column>
      <el-table-column :label="$t('名称')" prop="name" show-overflow-tooltip></el-table-column>
      <el-table-column :label="$t('类型')" prop="type" show-overflow-tooltip></el-table-column>
      <el-table-column label="版本" prop="version" show-overflow-tooltip></el-table-column>
      <el-table-column
        :label="$t('描述')"
        prop="description"
        show-overflow-tooltip
      ></el-table-column>
      <!-- <el-table-column :label="$t('支撑应用数')" prop="applicationNum"></el-table-column>
      <el-table-column :label="$t('调用次数')" prop="callnum"></el-table-column> -->
      <el-table-column :label="$t('状态')" width="120" prop="statusName" show-overflow-tooltip>
      </el-table-column>
      <el-table-column label="创建时间" width="200" prop="creationTime" show-overflow-tooltip>
      </el-table-column>
      <el-table-column label="是否启用" width="120">
        <template slot-scope="scope">
          <el-switch
            v-model="scope.row.isEnabled"
            :disabled="!$hasAccess('update')"
            @change="changeState(scope.row)"
          ></el-switch>
        </template>
      </el-table-column>
      <el-table-column :label="$t('操作')" width="280">
        <template slot-scope="scope">
          <el-button size="mini" @click="publishOne(scope.row)" :disabled="!$hasAccess('publish')"
            >发布</el-button
          >
          <el-button
            size="mini"
            @click="handleRow(scope.row, 'read')"
            :disabled="!$hasAccess('read')"
            >{{ $t('view') }}</el-button
          >
          <el-button
            :disabled="!$hasAccess('update')"
            size="mini"
            @click="handleRow(scope.row, 'edit')"
            >{{ $t('edit') }}</el-button
          >
          <el-button
            :disabled="!$hasAccess('delete')"
            size="mini"
            @click="deleteRow([scope.row.id])"
            >{{ $t('delete') }}</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <!-- table end -->
    <!-- pagigation start -->
    <el-pagination
      class="mt-20px float-right"
      background
      @size-change="searchTableData()"
      @current-change="findTableData()"
      :current-page.sync="page.pageNo"
      :page-sizes="$pageSizeAll"
      :page-size.sync="page.pageSize"
      layout="total, sizes, prev, pager, next"
      :total="page.pageTotal"
    ></el-pagination>
    <!-- pagigation end -->

    <wiz-upload-file
      v-dialogDrag
      @refreshList="searchTableData"
      :uploadFileProps="uploadFileProps"
      @exportTemplate="exportTemplate"
      @importTemplate="importTemplate"
    ></wiz-upload-file>
  </el-card>
</template>

<script>
// eslint-disable-next-line import/no-extraneous-dependencies
import { OpenApiApi } from '@wiz-api/open-api-management'
import FnMixins from '@/assets/js/fnMixins'
import dayjs from 'dayjs'

const openApiApi = new OpenApiApi()
export default {
  name: 'apiApply',
  mixins: [FnMixins],
  data() {
    return {
      tableLoading: true,
      apiTypes: [],
      tableData: [],
      searchCondition: {
        keyWord: null,
        type: null,
        state: null,
      },
      page: {
        pageNo: 1,
        pageSize: 15,
        pageTotal: 0,
      },
      statusList: [],
      uploadFileProps: {
        visible: false, // 是否开启弹窗
        active: 1, // 目前状态页面1为下载模板 2为上传模板 3为完成
        btnLoading: false, // 按钮加载状态
        isTestAndVerify: true, // 是否开启校验格式
        type: ['xls', 'xlsx'], // 检验文件格式，为数组可传多种同类型格式
        successCount: 0, // 上传成功条数
        failureCount: 0, // 上传失败条数
        resultFile: '', // 导入结果id，下载导入结果时需要使用
      },
      exportLoading: false,
      idList: [],
      publishLoading: false,
      deleteLoading: false,
    }
  },
  computed: {
    tableHeight() {
      return `${window.innerHeight - 220}px`
    },
    isJumpRequest() {
      return this.$route.query.isJumpRequest || ''
    },
  },
  methods: {
    selectionChange(val) {
      this.idList = val.map((item) => {
        return item.id
      })
    },
    // 批量发布
    async batchPublish() {
      this.publishLoading = true
      const [err, res] = await openApiApi.publishList({
        body: this.idList,
      })
      this.publishLoading = false
      if (!err) {
        this.$message.success('发布成功')
        this.searchTableData()
        this.idList = []
        this.$nextTick(() => {
          this.$refs.table.clearSelection()
        })
      }
    },
    // 单个发布
    async publishOne(row) {
      const [err, res] = await openApiApi.publishList({
        body: [row.id],
      })
      if (!err) {
        this.$message.success('发布成功')
        this.searchTableData()
      }
    },
    // 导入
    importFile() {
      this.uploadFileProps.visible = true
      this.uploadFileProps.active = 0
    },
    // 下载导入模板
    async exportTemplate() {
      const [err, res] = await openApiApi.downloadTemplate()
      // 返回的是文件流
      if (!err) {
        this.downLoadBlob({
          name: 'API发布导入模板.xlsx',
          data: res,
        })
      }
    },
    // 上传已填写的模板
    async importTemplate(file) {
      this.uploadFileProps.btnLoading = true
      const formData = new FormData()
      _.forIn({ file }, (value, key) => {
        formData.append('file', value)
      })
      const [err, res] = await openApiApi.callImport({
        file: formData.get('file'),
      })
      if (!err) {
        this.uploadFileProps.active = 2
        this.downLoadBlob({
          name: 'API发布导入明细.xlsx',
          data: res,
        })
        this.searchTableData()
      }
      this.uploadFileProps.btnLoading = false
    },
    // 导出
    async exportFile() {
      this.exportLoading = true
      const [err, res] = await openApiApi.callExport({
        body: {
          keywords: this.searchCondition.keyWord,
          type: this.searchCondition.type,
          status: this.searchCondition.state,
        },
      })
      this.exportLoading = false
      // 返回的是文件流
      if (!err) {
        this.downLoadBlob({
          name: 'API发布导出结果.xlsx',
          data: res,
        })
      }
    },
    // 获取状态
    async getStatus() {
      const [err, res] = await openApiApi.getStatus()
      if (!err) {
        this.statusList = _.map(res, (item) => {
          return {
            label: item.item2,
            value: item.item1,
          }
        })
      }
    },
    handleRow(row, type) {
      this.$router.push(`./api-release-create?id=${row.id}&type=${type}`)
    },
    deleteRow(id) {
      this.$confirm('是否确定要删除该数据?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(async () => {
          this.tableLoading = true
          const [err, res] = await openApiApi.deleteMany({
            ids: id,
          })
          this.tableLoading = false
          if (!err) {
            this.$message.success('删除成功')
            this.idList = []
            this.$nextTick(() => {
              this.$refs.table.clearSelection()
            })
            if (this.tableData.length === 1 && this.page.pageNo > 1) {
              this.page.pageNo -= 1
              this.findTableData()
              return
            }
            this.findTableData()
          }
        })
        .catch(() => {
          this.$message.info('取消删除')
        })
    },
    async changeState(row) {
      const reqData = {
        isEnabled: row.isEnabled,
        id: row.id,
      }
      this.tableLoading = true
      const [err, res] = await openApiApi.modifyAvailableStatus(reqData)
      this.tableLoading = false
      if (!err) {
        this.$message.success('更新状态成功')
        this.searchTableData()
      }
    },
    async findApiType() {
      const [err, res] = await openApiApi.getDistinctApiType()
      if (!err) {
        this.apiTypes = _.map(res, (item) => {
          return {
            label: item,
            value: item,
          }
        })
      }
    },
    searchTableData() {
      this.page.pageNo = 1
      this.findTableData()
    },
    async findTableData() {
      const reqData = {
        skipCount: this.page.pageNo,
        maxResultCount: this.page.pageSize,
        sorting: '',
        keywords: this.searchCondition.keyWord,
        type: this.searchCondition.type,
        status: this.searchCondition.state,
      }
      this.tableLoading = true
      const [err, res] = await openApiApi.getList(reqData)
      this.tableLoading = false
      if (!err) {
        this.tableData = _.map(res.items, (item) => {
          if (item.creationTime) {
            item.creationTime = dayjs(new Date(item.creationTime)).format('YYYY-MM-DD HH:mm:ss')
          }
          return item
        })
        this.page.pageTotal = res.totalCount
        _.forEach(this.tableData, (item) => {
          item.isEnabled = item.isEnabled === 1 // 0:否 1:是
        })
      }
    },
  },
  async created() {
    this.findApiType()
    this.getStatus()
    this.searchTableData()
  },
  mounted() {},
  activated() {
    if (this.isJumpRequest) {
      this.searchCondition.state = 2
    }
    this.searchTableData()
  },
}
</script>

<style lang="scss" scoped>

/deep/ .el-form-item {
  margin-bottom: 0px !important;
}

</style>
